import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");

// Remove prerendered SEO tags (injected into raw HTML by scripts/inject-seo.js for
// crawlers) before React mounts, so React's own metadata stays the single source of
// truth and no duplicate title/meta/canonical/hreflang tags appear post-hydration.
document.querySelectorAll('[data-rh-prerender]').forEach((el) => el.remove());

// For react-snap compatibility: use hydrateRoot if content exists
if (rootElement.hasChildNodes()) {
  // Prerendered content exists, use hydrateRoot
  ReactDOM.hydrateRoot(rootElement, <App />);
} else {
  // No prerendered content, use createRoot (dev mode)
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
